import { fetchRequest, postRequest, deleteRequest } from 'services/api.service';

export async function fetchScriptProgressV2(leadId: string) {
  return fetchRequest(`/v2/leads/${leadId}/script/progress`);
}

export async function clearScriptAnswerV2(leadId: string, scriptStepId: string) {
  return deleteRequest(`/v2/leads/${leadId}/script/steps/${scriptStepId}/answer`);
}

export async function updateScriptAnswerV2(leadId: string, scriptStepId: string, answer: string) {
  return postRequest(`/v2/leads/${leadId}/script/steps/${scriptStepId}/answer`, { answer });
}

export async function continueAutomation(leadId: string) {
  return postRequest(`/leads/${leadId}/automated-follow-ups`);
}
